import { gql } from '@apollo/client';

export const QUERY_USER_RESTRICTION = gql`
    query Obt_getUserRestriction {
        obtGetUserRestriction {
            companyCode
            departmentCode
            legalTabName
        }
    }
`;

export const QUERY_UPDATE_CONTACT = gql`
    mutation Obt_updateContactDetails($contactModel: IObtContactModelInput!) {
        obtUpdateContactDetail(contactModel: $contactModel) {
            id
            partnerno
            idpartner
            companycode
            role
            mail
            source
            valid
            name1
            name2
            department
            phone
            fax
            error
            anlageUser
            anlageDatum
            aenderungUser
            aenderungDatum
        }
    }
`;

export const QUERY_UPDATE_LEGAL = gql`
    mutation Obt_updateLegalDetails($legalModel: IObtPartnerLegalInput!) {
        obtUpdatePartnerLegalDetail(legalModel: $legalModel) {
            localcode
            codicedest
            pecaddress
        }
    }
`;

export const QUERY_DELETE_LEGAL = gql`
    mutation Obt_deletePartnerLegalDetail($legalModel: IObtPartnerLegalInput!) {
        obtDeletePartnerLegalDetail(legalModel: $legalModel) {
            localcode
            codicedest
            pecaddress
        }
    }
`;

export const QUERY_UPDATE_CHANNEL = gql`
    mutation Obt_updateChannelDetails($channelModel: IObtChannelModel!) {
        obtUpdateChannelDetail(channelModel: $channelModel) {
            id
            partnerno
            idpartner
            companycode
            invprocess
            validfrom
            validto
            status
            channeltype
            direction
            format
            count
            provider
            newProcess
            eskerOnboarded
        }
    }
`;

export const UPDATE_LIETWEGS_LEGAL_CHANNEL = gql`
    mutation Obt_updateLietwegsLegalChannel($idPartner: Float!, $partnerNo: String!, $companyCode: String!) {
        obtUpdateLietwegsLegalChannel(idPartner: $idPartner, partnerNo: $partnerNo, companyCode: $companyCode)
    }
`;

export const QUERY_SELECT_OPTIONS = gql`
    query Obt_getSelectOptionsByNamesQuery($lang: String!) {
        obtGetSearchSelectionOptions(lang: $lang) {
            countries {
                _id
                name
                value
            }
            languages {
                _id
                name
                value
            }
            rollouts {
                _id
                name
                value
            }
            companyCodes {
                _id
                name
                value
            }
            systemCodes {
                _id
                name
                value
            }
        }
    }
`;

export const QUERY_UPDATE_PARTNER_COMPANY_DETAILS = gql`
    mutation Obt_updatePartnerCompanyDetails($partnerCompany: IObtPartnerCompanyModel!) {
        obtUpdatePartnerCompanyDetails(partnerCompany: $partnerCompany) {
            id
            partnerno
            idpartner
            companycode
            remark
        }
    }
`;

export const GET_CHANNEL_DATA_BY_PARTNER_DETAILS = gql`
    query getObtChannelData($category: String!, $system: String!, $companyCode: String!) {
        obtGetObtChannelData(category: $category, system: $system, companyCode: $companyCode) {
            category
            system
            companyCode
            invProcess
            status
            direction
            provider
            format
            channel
        }
    }
`;

export const QUERY_PARTNER_DETAILS = gql`
    query Obt_partnerDetailsQuery($filters: IObtSearchModel!) {
        obtGetPartnerDetails(filters: $filters) {
            partnerMain {
                id
                partnerno
                masterpartnerno
                remark
                activity
                blockReason
                category
                systemid
                taxId
            }
            partnerCompany {
                id
                partnerno
                companycode
                remark
                cbuno
                aparpartnerlink
                anlageUser
                anlageDatum
                aenderungUser
                aenderungDatum
            }
            partnerAddress {
                id
                partnerno
                partnername
                street1
                street2
                postalcode
                pobox
                city
                region
                registercourt
                countrycode
                phone
                language
                anlageUser
                anlageDatum
                aenderungUser
                aenderungDatum
            }
            partnerContact {
                id
                partnerno
                idpartner
                companycode
                role
                mail
                source
                valid
                name1
                name2
                department
                phone
                fax
                error
                anlageUser
                anlageDatum
                aenderungUser
                aenderungDatum
                status
            }
            partnerChannel {
                id
                partnerno
                idpartner
                companycode
                invprocess
                validfrom
                validto
                status
                channeltype
                direction
                format
                count
                provider
                newProcess
                routeId
                anlageUser
                anlageDatum
                aenderungUser
                aenderungDatum
            }
            partnerLegal {
                id
                idpartner
                hstcode
                localcode
                codicedest
                pecaddress
                leitwegsId
                leitwegsEmail
                peppolId
            }
            partnerRun {
                id
                partnerno
                idpartner
                companycode
                status
                startOnboarding
                estimateOnboardingDate
                error
                wave
            }
            partnerDoc {
                id
                partnerno
                companycode
                month
                year
                invType
                channel
                count
                anlageUser
                anlageDatum
                aenderungUser
                aenderungDatum
            }
            partnerVatcode {
                id
                partnerno
                country
                vatcode
                anlageUser
                anlageDatum
                aenderungUser
                aenderungDatum
            }
        }
    }
`;

export const QUERY_REFRESH_PARTNER_CONTACT = gql`
    query Obt_refreshPartnerContacts($filters: IObtSearchModel!) {
        obtRefreshPartnerContactDetails(filters: $filters) {
            id
            partnerno
            idpartner
            companycode
            role
            mail
            source
            valid
            name1
            name2
            department
            phone
            fax
            error
            anlageDatum
            aenderungDatum
            anlageUser
            aenderungUser
            status
        }
    }
`;

export const QUERY_REFRESH_PARTNER_CHANNEL = gql`
    query Obt_refreshPartnerChannels($filters: IObtSearchModel!) {
        obtRefreshPartnerChannelsDetails(filters: $filters) {
            id
            partnerno
            idpartner
            companycode
            invprocess
            validfrom
            validto
            status
            channeltype
            direction
            format
            count
            provider
            newProcess
            routeId
            anlageUser
            anlageDatum
            aenderungUser
            aenderungDatum
            formatVersion
        }
    }
`;

export const QUERY_EXISTING_PARTNER_CONTACTS = gql`
    query getExistingPartnerContacts($contactsRequest: IObtExistingContactsRequestInput!) {
        obtExistingPartnerContacts(contactsRequest: $contactsRequest) {
            id_partner
            partnerno
            companycode
            role
            email
            department
            anlageUser
            anlageDatum
            aenderungUser
            aenderungDatum
        }
    }
`;

export const QUERY_PARTNER_LEGAL_VAT_CODE = gql`
    query getPartnerLegalVatCode($partnerno: String!, $idpartner: Float!) {
        obtGetPartnerLegalVatNipInfo(partnerno: $partnerno, idpartner: $idpartner) {
            id
            vatcode
            countrycode
        }
    }
`;

export const QUERY_GET_OBT_PEPPOL_DATA = gql`
    query getObtPeppolData($country: String!) {
        obtGetObtPeppolData(country: $country) {
            schemeid
            country
            icdcode
            schemename
            valididlength
        }
    }
`;
